import { useCallback, useEffect, useState } from "react";
import {
  ProductsAPI,
  BlogsAPI,
  FaqsAPI,
  OrdersAPI,
} from "./supabaseServices";

/** Generic hook wrapper: calls an async fn and tracks {data, loading, error}. */
export function useAsync(fn, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const run = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fn();
      if (res && res.error) throw res.error;
      setData(res && "data" in res ? res.data : res);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    run();
  }, [run]);

  return { data, loading, error, refetch: run };
}

export const useProducts = (opts = {}) =>
  useAsync(() => ProductsAPI.list(opts), [JSON.stringify(opts)]);

export const useProduct = (slug) =>
  useAsync(() => ProductsAPI.bySlug(slug), [slug]);

export const useBlogs = (opts = {}) =>
  useAsync(() => BlogsAPI.list(opts), [JSON.stringify(opts)]);

export const useBlog = (slug) => useAsync(() => BlogsAPI.bySlug(slug), [slug]);

export const useFaqs = () => useAsync(() => FaqsAPI.list(), []);

export const useOrdersByEmail = (email) =>
  useAsync(() => (email ? OrdersAPI.byEmail(email) : Promise.resolve({ data: [] })), [email]);
